import React, { AriaAttributes, AriaRole } from 'react';
import classnames from 'classnames';
import s from './IconWrap.scss';

export enum IconSize {
  /** 8px */
  NANO = 'nano',
  /** 12px */
  TINY = 'tiny',
  /** 16px */
  SMALLER = 'smaller',
  /** 18px */
  SMALL = 'small',
  /** 20px */
  COMPACT = 'compact',
  /** 24px */
  MEDIUM = 'medium',
  /** 32px */
  LARGE = 'large',
  /** 36px */
  BIG = 'big',
  /** 40px */
  BIGGER = 'bigger',
  /** 48px */
  HUGE = 'huge',
  /** 60px */
  JUMBO = 'jumbo',
  /** 72px */
  GIANT = 'giant',
  /** 96px */
  MEGA = 'mega',
}

export enum IconPixelSize {
  NANO = 8, // 8px
  TINY = 12, // 12px
  SMALLER = 16,
  SMALL = 18, // 18px
  COMPACT = 20, // 20px
  MEDIUM = 24, // 24px
  LARGE = 32,
  BIG = 36, // 36px
  BIGGER = 40, // 40px
  HUGE = 48, // 48px
  JUMBO = 60, // 60px
  GIANT = 72, // 72px
  MEGA = 96, // 96px
}

export interface Props {
  className?: any;
  size?: IconSize;
  withPadding?: boolean;
  condensed?: boolean;
  customSizable?: boolean;
  verticalAlign?: string;
  disableDefaultColors?: boolean;
  role?: AriaRole;
  onAnimationEnd?: React.AnimationEventHandler;
  'aria-hidden'?: AriaAttributes['aria-hidden'];
  'aria-label'?: AriaAttributes['aria-label'];
  containerRef?: React.RefObject<HTMLElement | null> | ((node: HTMLElement | null) => void);
  style?: React.CSSProperties;
}

const IconWrap: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  size = IconSize.MEDIUM,
  withPadding = false,
  condensed,
  customSizable = false,
  children,
  verticalAlign,
  disableDefaultColors,
  'aria-hidden': ariaHidden,
  'aria-label': ariaLabel,
  onAnimationEnd,
  containerRef,
}) => (
  <span
    className={classnames(
      s['root'],
      !customSizable && s[size],
      withPadding && s['withPadding'],
      condensed && s['condensed'],
      verticalAlign && s[`vertical-align-${verticalAlign}`],
      !disableDefaultColors && s['default-colors'],
      className
    )}
    aria-hidden={ariaHidden}
    aria-label={ariaLabel}
    onAnimationEnd={onAnimationEnd}
    ref={containerRef}
  >
    {children}
  </span>
);
IconWrap.displayName = 'IconWrap';

export default IconWrap;
